import { render } from "./amendment-setup-area.vue?vue&type=template&id=923c6dac"
import script from "./amendment-setup-area.vue?vue&type=script&lang=js"
export * from "./amendment-setup-area.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__